import * as THREE from 'three';

/**
 * A node to hold all XR Blocks Systems.
 */
export class XRSystems extends THREE.Group {
  type = 'XRSystems';
  name = 'XR Blocks Systems';
}
